/** @format */

import Icons from "../../Assets/Icons";
export default function FilterComponent({ filters, deleteSearch }) {
  return (
    <div className='filter-cont'>
      <div className='filter-cont__filters'>
        <Icons name='filter' />
        <h4>تصفية </h4>
        {Object.keys(filters).map((item) => (
          <button key='item' dir='rtl' onClick={() => deleteSearch(item)}>
            {filters[item].label}: {filters[item].value}
            <Icons name='close' />
          </button>
        ))}
      </div>
    </div>
  );
}
